<template>
  <el-upload :disabled="props.disabled" class="avatar-uploader" action="https://upload.qiniup.com" :accept="accept" :data="uploadData"
    :show-file-list="false" :on-success="handleSuccess" :before-upload="beforeUpload">
    <img v-if="imageUrl" :src="imageUrl" :style="{width:props.imageSize.width,height:props.imageSize.height}" class="avatar" />
    <div v-else :style="{width:props.imageSize.width,height:props.imageSize.height}" class="plus_icon">
      <img  src="@/assets/image/add.svg" alt="">
    </div>
    <!-- <el-icon v-else class="avatar-uploader-icon">
      <Plus />
    </el-icon> -->
    <template #tip>
      <div style="text-align: center;font-size: 14px;color: #666;">{{props.tiptext}}</div>
      <!-- <div>
        <el-icon @click="handleRemove" v-if="imageUrl">
          <Delete />
        </el-icon>
      </div> -->
      <!-- <p class="upload-b-tips">
        只能上传jpg、png、jpeg文件，且不超过{{ imgSize }}M，尺寸为{{ pxSize }}px
      </p> -->
    </template>
  </el-upload>
</template>

<script setup>
import { onMounted, reactive, ref, watch } from 'vue'
import { ElMessage } from 'element-plus'
// import { Plus } from '@element-plus/icons-vue'
import { getUploadToken } from '@/api/common'
import { qiniuImgBaseUrl } from '@/config/index.js'
const props = defineProps({
  defaultUrl: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  accept: {
    type: String,
    default: '.jpg, .jpeg, .png'
  },
  imgSize: {
    type: Number,
    default: 3
  },
  pxSize: {
    type: String,
    default: '1080x720'
  },
  tiptext: {
    type: String,
    default: ''
  },
  imageSize: {
    type: Object,
    default: () => ({width:'243px',height:'153px'})
  },
})

const emit = defineEmits(['onSuccess', 'removeImage'])

const imageUrl = ref('')
const channelVisitUrl = ref('')
const uploadData = reactive({
  token: '',
  key: ''
})
watch(() => props.defaultUrl,
  (newval, oldval) => {
    imageUrl.value = newval
  }, { immediate: true, })
onMounted(() => {
  getImgParams()
})
const getImgParams = () => {
  //获取上传图片所需参数
  getUploadToken().then((res) => {
    // console.log('token', res);
    if (res.result) {
      uploadData.token = res.result.token
      uploadData.key = res.result.key
    }
  })
}
// //删除文件触发
// const handleRemove = (a, b) => {
//   imageUrl.value = ''
//   emit('removeImage')
// }
//文件上传成功
const handleSuccess = (res, file) => {
  console.log(res, file);
  // imageUrl.value = URL.createObjectURL(file.raw)
  channelVisitUrl.value = `${qiniuImgBaseUrl}${res.key}`
  emit('onSuccess', channelVisitUrl.value)
}
//文件上传之前
const beforeUpload = (file) => {
  return new Promise((resolve, reject) => {
    validateFile(file)
      .then(() => {
        //获取上传图片所需参数
        getUploadToken().then((res) => {
          if (res.result) {
            uploadData.token = res.result.token
            uploadData.key = res.result.key
          }
          return resolve()
        })
      })
      .catch(() => {
        return reject()
      })
  })
}
//校验文件是否符合规则
const validateFile = (file) => {
  const isJPG = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg'
  const isLt2M = file.size / (props.imgSize * 1024 * 1024) < 1
  // console.log(file.size,props.imgSize * 1024 * 1024);
  // console.log(file.size, props.imgSize);
  return new Promise((resolve, reject) => {
    if (!isJPG) {
      ElMessage({
                message: '上传图片只能是 jpg/png/jpeg 格式!',
                customClass: "custom-message2",
            })
      // ElMessage.error('上传图片只能是 jpg/png/jpeg 格式!')
      reject(false)
    }
    if (!isLt2M) {
      ElMessage({
                message: `上传图片大小不能超过${props.imgSize}MB!`,
                customClass: "custom-message2",
            })
      // ElMessage.error(`上传图片大小不能超过${props.imgSize}MB!`)
      reject(false)
    }

    // uploadData.key = `upload_pic_${new Date().getTime()}`

    const allowUpload = isJPG && isLt2M
    if (allowUpload) {
      resolve(true)
    }
  })
}
</script>

<style scoped>
.avatar-uploader .avatar {
  display: block;
}
</style>

<style>
.avatar-uploader .el-upload {
  border: 0.5px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.plus_icon {
  background-color: rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* .avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
} */


.upload-b-tips {
  font-size: 12px;
  color: red;
}
</style>
